
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationQ as ObiLocationQElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-q.js';
 
 
 

 
 export const ObiLocationQ = createComponent({
   react: React,
   tagName: 'obi-location-q',
   elementClass: ObiLocationQElement,
   events: {
     
   }
  });
 
 